import React, { Component } from 'react';
import { generatePath } from 'react-router-dom';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { IntlProvider } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartPieAlt, faCog, faShoppingBag, faUserPlus, faCashRegister, faComputerClassic, faBoxes
} from '@fortawesome/pro-light-svg-icons';
import { throttle } from 'lodash';
import { Spin } from 'antd';
import { AuthenticatedRouter, AnonymousRouter, Route } from './routes';
import * as AuthActions from './state/actions/creators/auth.actioncreator';
import { changeLanguage, setBreakPoint } from './state/actions/creators/app.actioncreator';
import AppSidebar from './modules/app/container/AppSidebar.layout';
import AppHeader from './modules/app/container/AppHeader.layout';
import messagesEn from './assets/translations/en.json';
import messagesEs from './assets/translations/es.json';
import messagesPt from './assets/translations/pt.json';
import messagesCa from './assets/translations/ca.json';
import messagesFr from './assets/translations/fr.json';
import messagesCo from './assets/translations/co.json';
import messagesCl from './assets/translations/cl.json';
import messagesMx from './assets/translations/mx.json';
import messagesBq from './assets/translations/bq.json';
import { generateGioDataURL, generateSiteURL } from './helpers/url.helper';
import { Flex, Text } from './modules/shared/components';
import { obtenerValorPermiso } from './helpers/auth.helper';
import { setVisible } from './state/actions/creators/caja.actioncreator';
import { PEDIDOS_LENTES_CONTACTO, ROUTE_DOCUMENT, ROUTE_DOCUMENT_TIENDA, ROUTE_PACIENTES_NEW } from './routes.constants';
import CajaModal from './modules/caja/components/modal/Caja.modal';
import { DESKTOP, DESKTOP_WIDTH, TABLET } from './state/actions/constants/app.constants';
import { logoutAction } from './state/actions/creators/auth.actioncreator';
import {MIN_WIDTH} from "./state/reducers/app.reducer";

const messages = {
  en: messagesEn,
  es: messagesEs,
  pt: messagesPt,
  ca: messagesCa,
  fr: messagesFr,
  co: messagesCo,
  cl: messagesCl,
  mx: messagesMx,
  bq: messagesBq,
};

class App extends Component {
  constructor(props, context) {
    super(props, context);
    this.language = undefined;
    // Persistencia de datos para evitar las llamadas al BE repetidas cuando volvemos a de una página a otra.
    // Necesitamos borrar el storage cada vez que actualizamos manualmente la página para que no haya fallos.
    sessionStorage.clear();
  }

  setBkPoint() {
    const {
      breakPoint, setBreakPoint,
    } = this.props;
    const newBreakPoint = window.innerWidth <= DESKTOP_WIDTH ? TABLET : DESKTOP;
    if (breakPoint !== newBreakPoint) {
      setBreakPoint(newBreakPoint);
    }
  }


  componentDidMount() {
    const {
      token, logoutAction, user, setBreakPoint,
    } = this.props;
    if (token !== null) {
      localStorage.setItem('token', token);
    }

    const calcInnerWidth = throttle(() => {
      this.setBkPoint();
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    calcInnerWidth();

    const inIframe = window.top != window.self;

    if (inIframe) {
      const lang = user ? user.lang : 'es_ES';
      const langKey = lang ? lang.split('_')[0] : 'es';
      if (langKey.length === 2) this.language = langKey;
      else this.language = 'es';
    }
    if (token !== null) {
      try {
        const expiracionToken = new Date(JSON.parse(atob(token.split('.')[1])).exp * 1000);
        const fechaActual = new Date();
        if (fechaActual > expiracionToken) logoutAction();
      } catch (e) {

      }
    }
    return () => window.removeEventListener('resize', calcInnerWidth);
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.token !== this.props?.token) return true;
    if (nextProps.breakPoint !== this.props?.breakPoint) {
      return false;
    }
    return true;
  }

  getMenu() {
    const { token, permisos, setVisible, user } = this.props;

    const menu = [
      {
        key: '1',
        icon: <div style={{ marginLeft: 9 }}><FontAwesomeIcon icon={faUserPlus} size="2x" /></div>,
        text: <Text>Clientes</Text>,
        onClick: () => {
          if (this.props.history.location.pathname !== generatePath(ROUTE_PACIENTES_NEW)) {
            this.props.history.push(generatePath(ROUTE_PACIENTES_NEW));
          }
        },
      },
      {
        key: '2',
        icon: <FontAwesomeIcon icon={faShoppingBag} size="2x" />,
        text: <Text>Encargos</Text>,
        visible: false,
      },
      {
        key: '3',
        icon: <FontAwesomeIcon icon={faCashRegister} size="2x" />,
        text: <Text>Caja</Text>,
        visible: false,
        onClick: () => setVisible(true, 'SET_VISIBLE'),

      },
    ];
    const permisoGioData = obtenerValorPermiso({ permisos, clave: 'acceso_giodata' });
    if (permisoGioData) {
      menu.push({
        key: 'menu_giodata',
        icon: <FontAwesomeIcon icon={faChartPieAlt} size="2x" />,
        text: <Text>GioData</Text>,
        disabled: true,
        visible: false,
        onClick: () => window.open(generateGioDataURL(token)),
      });
    }
    menu.push({
      key: 'menu_catalogos',
      icon: <FontAwesomeIcon icon={faBoxes} size="2x" />,
      text: <Text>Catálogo</Text>,
      visible: true,
      onClick: () => this.props.history.push(generatePath(PEDIDOS_LENTES_CONTACTO)),
    });
    const permisoSiteUrl = permisos?.configuracion?.site_url;
    menu.push({
      key: 'menu_site',
      icon: <FontAwesomeIcon icon={faCog} size="2x" />,
      text: <Text>GioSite</Text>,
      visible: false,
      onClick: () => window.open(generateSiteURL(permisoSiteUrl, token)),
    });
    menu.push({
      key: 'menu_documentos',
      icon: <FontAwesomeIcon icon={faComputerClassic} size="2x" />,
      text: <Text>Documentos</Text>,
      visible: true,
      submenu: [
        {
          key:'documentos',
          text: <Text>Documentos</Text>,
          disabled: false,
          onClick: () => this.props.history.push(generatePath(ROUTE_DOCUMENT_TIENDA, {entidadId: user.cliente_deipe, entidadTipoId: 6, tiendaId: user.user_info.tienda_id})),
        },
        {
          key:'acceso_site',
          text: <Text>Acceso SITE</Text>,
          disabled: false,
          onClick: () => window.open(generateSiteURL(permisoSiteUrl, token)),
        }
      ],
    });
    return menu;
  }

  render() {
    const {
      history, token, idioma, user, logoutAction, loadingCore,
    } = this.props;
    const inIframe = window.top != window.self;
    const locale = (inIframe) ? this.language : idioma;
    if (loadingCore) return <Flex style={{ width: '100%', height: '100%' }} alignItems="center" justifyContent="center"><Spin /></Flex>;
    const menu = this.getMenu();
    let sidebar = (
      <AppSidebar
        menu={menu}
      />
    );

    if (inIframe) sidebar = null;
    const header = !inIframe ? <AppHeader history={history} logoutAction={logoutAction} /> : null;

    let Router = null;
    if (token !== null) {
      Router = <AuthenticatedRouter history={history} sidebar={sidebar} header={header} inIframe={inIframe} />;
    } else {
      Router = <AnonymousRouter history={history} />;
    }

    return (
      <IntlProvider locale={locale} messages={messages[idioma]}>
        { Router }
        {user ? <CajaModal /> : null}
      </IntlProvider>
    );
  }
}

App.propTypes = {
  token: PropTypes.string,
  history: PropTypes.object.isRequired,
  logoutAction: PropTypes.func.isRequired,
  loadingCore: PropTypes.bool,
};

App.defaultProps = {
  token: null,
  loadingCore: false,
};

const mapStateToProps = ({
  auth, navigation, app, sagas,
}) => ({
  token: auth.token,
  user: auth.user,
  permisos: auth.permisos,
  navigation,
  idioma: app.idioma,
  breakPoint: app.breakPoint,
  loadingCore: sagas.CORE_OBTENER_ENTIDADES_BASICAS ? sagas.CORE_OBTENER_ENTIDADES_BASICAS.running : false,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ...AuthActions,
    changeLanguage,
    setVisible,
    setBreakPoint,
    logoutAction,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
